/**
 * OpenhomeCardAction
 * 
 * @Author: Focci
 * @Date: 2023-08-16 21:56:47
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-16 21:56:47
 */

import PropTypes from 'prop-types'
import clsx from 'clsx'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import AddIcon from '@mui/icons-material/Add'
import { ButtonBase } from '@comp/material'
import { useTranslations } from 'next-intl'

function getClassNameAndChild(added, auction, th) {
  const className = added 
    ? 'bg-cf2'
    : (auction ? 'bg-primary text-white' : 'bg-[#0FB007] text-white')
    
  const content = added
    ? th('checkOutViewingsItinerary')
    : th('addViewingsItinerary')

  return {
    className,
    content,
  }
}

function OpenhomeCardButton({
  className = '',
  loading = false,
  added = false,
  onClick = () => {},
  children,
}) {
  return (
    <ButtonBase
      disabled={loading}
      className="rounded-full"
      onClick={onClick}
      aria-label="Add openhome"
    >
      <div className="flex items-center gap-x-2 pl-2 whitespace-nowrap">
        {loading ? 'Loading...' : <span className="hidden md:block">{children}</span>}
        <div 
          className={clsx([
            'w-6 h-6 rounded-lg flex items-center justify-center',
            loading ? 'opacity-50' : '',
            className
          ])}
        >
          {!added && <AddIcon />}
          {added && <KeyboardArrowRightIcon />}
        </div>
      </div>
    </ButtonBase>
  )
}

export default function OpenhomeCardAction({
  auction = false, // 是否为拍卖
  added = false, // 是否已添加
  ...buttonProps
}) {
  const th = useTranslations('house')
  const { className, content } = getClassNameAndChild(added, auction, th)

  return (
    <OpenhomeCardButton 
      className={className}
      added={added}
      {...buttonProps}
    >
      {content}
    </OpenhomeCardButton>
  )
}

OpenhomeCardAction.propTypes = {
  auction: PropTypes.bool,
  added: PropTypes.bool,
}
